const isEnter = ({ key }) => key === 'Enter';

export default isEnter;
